import { CATEGORY_SLUG_MAP } from '#app/constants/blog.js';
import { type CategorySlug } from '#app/types/blogs.js';

export const isBlogCategorySlug = (key: string): key is CategorySlug => {
  return Object.prototype.hasOwnProperty.call(CATEGORY_SLUG_MAP, key);
};
